import { PlaceholderPage } from '@/components/PlaceholderPage';

export function CampaignPage() {
  return <PlaceholderPage title="Community Campaigns" subtitle="Stub module (doc 12) — P2+." />;
}
